
        var result = require("!!../../../../node_modules/css-loader/index.js!./treatment-combination-search.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/treatment-combination-search.component.css
// module id = 2334
// module chunks = 1